export default __webpack_public_path__ + "static/media/rocks-05.c6008177.png";